import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsRemoteEduMixin extends Vue {
  get isRemoteEdu() {
    return this.$store.getters.hasApiModuleRemoteEdu;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isRemoteEduCheck.ts